import { LICENSES } from "@/utils/license";
import { IntlShape } from "react-intl";
import {
  array,
  check,
  maxLength,
  nonEmpty,
  nullish,
  object,
  pipe,
  string,
  trim,
  undefinedable,
  type InferInput,
  type InferOutput,
} from "valibot";
import { authorSchema } from "../DatasetVersionAuthorInput/schema";

export const SHORT_DESCRIPTION_MAX_SIZE = 50;

export const schema = (intl: IntlShape) =>
  object({
    shortDescription: nullish(
      pipe(
        string(),
        maxLength(SHORT_DESCRIPTION_MAX_SIZE, (issue) =>
          intl.formatMessage(
            { defaultMessage: "{count}/{maxChar} characters used" },
            { count: issue.input.length, maxChar: SHORT_DESCRIPTION_MAX_SIZE },
          ),
        ),
      ),
    ),
    tags: undefinedable(array(pipe(string(), nonEmpty(), trim()))),
    license: nullish(
      pipe(
        string(),
        nonEmpty(),
        trim(),
        check(
          (input) => LICENSES.some((license) => license === input),
          intl.formatMessage(
            { defaultMessage: "license must one of {licenses} " },
            { licenses: LICENSES.join(", ") },
          ),
        ),
      ),
    ),
    authors: nullish(array(authorSchema)),
  });

export type Schema = ReturnType<typeof schema>;
export type SchemaOutput = InferOutput<Schema>;
export type SchemInput = InferInput<Schema>;
export type { AuthorSchemaInput } from "../DatasetVersionAuthorInput/schema";
